import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authed/dashboard/o/$orgId/settings/profile')({
  component: ProfileLayout,
});

function ProfileLayout() {
  return <Outlet />;
}
